<template>
  <div
    class="m-2 mx-0 message"
    :class="messageClass"
    :title="messageTimeLocalize"
  >
    <span class="actor">{{ message.sender_name }}</span>
    <p class="mt-1 mb-0 text-light p-2 px-3 rounded message-text">
      {{ message.message }}
      <span class="caret" />
    </p>
    <span class="text-xs text-muted">{{ messageTimeHumanize }}</span>
  </div>
</template>
<script>
import moment from 'moment-timezone';
import '../../../sass/app.scss';

export default {
  name: 'AgentMessage',
  props: {
    message: { default: null, required: true },
    me: { default: null, required: true },
  },
  computed: {
    messageTimeHumanize() {
      moment.locale('th');
      return moment(new Date(this.message.created_at)).fromNow();
    },
    messageTimeLocalize() {
      return moment(new Date(this.message.created_at)).format('LLLL');
    },
    messageClass() {
      let styleClass = '';
      switch (this.message.type) {
        case 'network':
          styleClass = this.message.sender_id == this.me ? 'send' : 'receive';
          break;
        default:
          styleClass = this.message.type;
      }
      return styleClass;
    },
  },
  created() {
    moment.locale('th');
  },
};
</script>
<style lang="scss" scoped>
.message {
  width: fit-content;
  max-width: 60vw;
  padding: 0 1rem;

  &.receive {
    .message-text {
      background-color: var(--secondary);
      position: relative;
      .caret {
        display: block;
        position: absolute;
        left: 0;
        top: -0.25rem;
        border: 0.5rem solid var(--secondary);
        border-right-color: transparent;
        border-top-color: transparent;
      }
    }
  }
  &.send {
    left: 100%;
    position: relative;
    transform: translateX(-100%);
    text-align: right;
    .message-text {
      background-color: var(--green);
      position: relative;
      .caret {
        display: block;
        position: absolute;
        right: 0;
        bottom: -0.25rem;
        border: 0.5rem solid var(--green);
        border-left-color: transparent;
        border-bottom-color: transparent;
      }
    }
    .actor {
      display: none;
    }
  }
  &.warning {
    margin: 1rem auto;
    width: 70%;
    left: 15%;
    position: relative;
    border-left: 5px solid var(--info);
    background-color: var(--info-soft);
    text-align: center;
    padding: 1rem;
    margin: 1rem auto;
    .message-text {
      background-color: var(--info-soft) !important;
      color: #000 !important;
    }
    .actor {
      display: none;
    }
    .text-muted {
      color: var(--info) !important;
    }
  }
  &.warning-caution {
    margin: 1rem auto;
    width: 70%;
    left: 15%;
    position: relative;
    border-left: 5px solid var(--warning);
    background-color: var(--warning-soft);
    text-align: center;
    padding: 1rem;
    margin: 1rem auto;
    .message-text {
      background-color: var(--warning-soft) !important;
      color: #000 !important;
    }
    .actor {
      display: none;
    }
    .text-muted {
      color: var(--warning) !important;
    }
  }
  &.warning-suspended {
    margin: 1rem auto;
    width: 70%;
    left: 15%;
    position: relative;
    border-left: 5px solid var(--danger);
    background-color: var(--danger-soft);
    text-align: center;
    padding: 1rem;
    margin: 1rem auto;
    .message-text {
      background-color: var(--danger-soft) !important;
      color: #000 !important;
    }
    .actor {
      display: none;
    }
    .text-muted {
      color: var(--danger) !important;
    }
  }
  &.remark {
    margin: 1rem auto;
    width: 70%;
    left: 15%;
    position: relative;
    border: 1px solid var(--gray);
    border-left-width: 5px;
    background-color: var(--gray-soft);
    text-align: center;
    padding: 1rem;
    margin: 1rem auto;
    .message-text {
      color: #000 !important;
      background-color: var(--light) !important;
    }
    .actor {
      display: none;
    }
    .text-muted {
      color: var(--gray) !important;
    }
  }
}
.time {
  font-size: 0.75em;
}
</style>
